<header class="relative bg-white border-b border-gray-100">
  <!-- Gradient background for all screen sizes -->
  <div class="absolute inset-0 bg-gradient-to-r from-emerald-500/5 via-transparent to-emerald-500/5"></div>

  <div class="relative flex items-center justify-between px-6 py-4 sm:px-8">
    <ng-content />
  </div>
</header>
